module.exports = __webpack_public_path__ + "static/media/spoken-word.59d61506.png";